import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'lib-range-date-filter',
  templateUrl: './range-date-filter.component.html',
  styleUrls: ['./range-date-filter.component.scss']
})
export class RangeDateFilterComponent implements OnInit, OnDestroy {
  private subs: Array<Subscription> = [];
  public date: { begin: Date, end: Date };

  /**
   *
   * Type of format to show date. See Angular DatePipe for options
   * @type {string}
   * @memberof DateFilterComponent
   */
  @Input() format: string = "dd/ MMMM /yyyy";
  @Input() id: string;
  /**
   *
   * Place holder of input
   * @type {string}
   * @memberof DateFilterComponent
   */
  @Input() placeholder: string = "";

  /**
   *
   * FormControl. If not provided default will be setted
   * @type {FormControl}
   * @memberof DateFilterComponent
   */
  @Input() dateFormControl: FormControl;
  @Input() date_subject: BehaviorSubject<{ begin: Date, end: Date }>;
  constructor() { }

  ngOnInit() {
    if (this.dateFormControl === undefined) {
      this.dateFormControl = new FormControl({
        date: [{ begin: new Date(), end: new Date() }]
      });
    }
    if (this.date_subject === undefined) {
      this.date_subject = new BehaviorSubject({ begin: new Date(), end: new Date() });
    }
    this.subs.push(
      this.date_subject
        .asObservable()
        .subscribe(next => {
          this.date = next ? next : undefined
        })
    );
  }
  onChange(event) {
    // this.date = event.value;
    let date = event.value;
    this.date_subject.next(date);
  }
  ngOnDestroy(): void {
    this.subs.forEach(value => value.unsubscribe());
  }

}
